const localInformations = () => import('@/views/cdds/LocalInformation')
const localTravelType  = () => import('@/views/cdds/LocalTravelType')
const localTravelTypeByProvince  = () => import('@/views/cdds/LocalTravelTypeByProvince')

const mainWidget = [
    {
      title: 'ข้อมูลกรมพัฒนาชุมชน',
      path: '/admin/widget/:category/:widget_code(144)',
      component: localInformations
    },
    {
      title: 'ข้อมูลกรมพัฒนาชุมชน',
      path: '/admin/widget/:category/:widget_code(144.1)',
      component: localTravelType
    },
    {
      title: 'ข้อมูลกรมพัฒนาชุมชน',
      path: '/admin/widget/:category/:widget_code(144.2)',
      component: localTravelTypeByProvince
    }
]

export default mainWidget.map(data => {
    const { path, title, component, redirect, children } = data

    return {
        path: path,
        name: title,
        component: component,
        redirect: redirect,
        meta: {
        title: title,
            requiresAuth: true,
            breadcrumb: title
        },
        children: children
    }
})